var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('van-swipe',{staticClass:"swiper",attrs:{"show-indicators":false,"loop":false}},_vm._l((_vm.detailList.contentName),function(item,index){return _c('van-swipe-item',{key:index},[_c('img',{staticClass:"img",attrs:{"src":item,"alt":""}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }